import React, { useEffect, useState } from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import FileImport from "components/FileImport";
import PropTypes from "prop-types";

const ImportFileModal = ({
  title,
  accepts,
  onOk,
  bodyText,
  okText,
  cancelText,
}) => {
  const dispatch = useDispatch();

  const [okButtonDisabled, setOkButtonDisabled] = useState(true);
  const [selectedFile, setSelectedFile] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!okButtonDisabled) {
      const formData = new FormData();
      formData.append("importedFile", selectedFile, selectedFile.name);

      onOk(formData);
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter" && !okButtonDisabled) {
      handleSubmit();
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.IMPORT_FILE));
  };

  useEffect(() => {
    if (selectedFile && selectedFile.name.endsWith(accepts)) {
      setOkButtonDisabled(false);
      setError("");
    } else {
      setOkButtonDisabled(true);
      if (selectedFile) {
        setError(
          `You can only upload ${accepts.replace(
            ".",
            ""
          )} files. Please chose a file with the extension '${accepts}'`
        );
      }
    }
  }, [selectedFile]);

  return (
    <Modal
      data-testid="import-file-modal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header closeButton>
        <b className="import_file_modal__header">{title}</b>
      </Modal.Header>
      <Modal.Body>
        <div className="import_file">
          <FileImport
            accepts={accepts}
            handleFileChange={handleFileChange}
            selectedFile={selectedFile}
            error={error}
            bodyText={bodyText}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          dataTestId="save-button"
          variant={buttonVariants.primary}
          onClick={handleSubmit}
          disabled={okButtonDisabled}
          content={okText || "Upload"}
        />
        <Button
          dataTestId="cancel-button"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content={cancelText || "Cancel"}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ImportFileModal;

ImportFileModal.propTypes = {
  title: PropTypes.string.isRequired,
  accepts: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  bodyText: PropTypes.string,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
};
